import { Row, Spin } from "antd";
import { useMemo } from "react";
import { Accounts } from "./Accounts";
import { ClosedAccounts } from "./Accounts/ClosedAccounts";
import { ISelectedConversation } from "../../../types/SelectedConversation";
import { NoMessageFound } from "./NoMessagesFound";

type ListProps = {
  data: any;
  isLoading: boolean;
  unread: boolean;
  conversation: ISelectedConversation | null;
  readConversation: (
    contractNumber: number,
    selectedConvValues: ISelectedConversation
  ) => void;
};

export const List = ({
  data,
  isLoading,
  unread,
  conversation,
  readConversation,
}: ListProps) => {
  const filteredItems: any[] = useMemo(() => {
    const values: any[] = [];

    data.forEach((item: any) => {
      const filteredConversations: any[] = item.conversations.filter(
        (conv: any) => {
          if (unread) {
            return conv.hasUnreadMessages;
          }

          return conv;
        }
      );

      if (filteredConversations.length > 0) {
        values.push({ ...item, conversations: filteredConversations });
      }
    });

    return values;
  }, [data, unread]);

  const items: any[] = useMemo(
    () => filteredItems.filter((item: any) => !item.isClosed),
    [filteredItems]
  );

  const closed: any[] = useMemo(
    () => filteredItems.filter((item: any) => item.isClosed),
    [filteredItems]
  );

  return (
    <Row className="list-container">
      {isLoading ? (
        <Row className="w-100 justify-center mt-10 pt-10">
          <Spin size="large" />
        </Row>
      ) : (
        <Row className="d-block w-100">
          {filteredItems.length !== 0 ? (
            <Row className="d-block mt-10 w-100">
              <Accounts
                data={items}
                conversation={conversation}
                readConversation={readConversation}
              />
              <ClosedAccounts
                data={closed}
                conversation={conversation}
                readConversation={readConversation}
              />
            </Row>
          ) : (
            <NoMessageFound />
          )}
        </Row>
      )}
    </Row>
  );
};
